$(function () {
    $('.feature-item').on('mouseenter', function () {
        const isMobile = window.matchMedia('(max-width: 767px)').matches;
        if (isMobile) return;

        const dot = $(this).find('.dot');
        const pk = $(this).find('.starpk');
        const yl = $(this).find('.staryl');
        const phone = $(this).find('.phone');
        const passbook = $(this).find('.passbook');
        const money = $(this).find('.money');
        const bagpk = $(this).find('.bagpk');
        const bagbu = $(this).find('.bagbu');
        const QRcode = $(this).find('.QRcode');
        const bell = $(this).find('.bell');
        const dialog = $(this).find('.dialog');

        gsap.to(dot, {
            scale: 1,
            duration: 0.5,
            opacity: 1,
            ease: "bounce.out"
        });
        gsap.to(pk, {
            scale: 1,
            rotate: 0,
            duration: 0.5,
            opacity: 1,
            ease: "bounce.out"
        });
        gsap.to(yl, {
            scale: 1,
            rotate: -45,
            duration: 0.5,
            opacity: 1,
            ease: "bounce.out"
        });
        if (phone.length > 0) {
            gsap.to(phone, {
                rotate: -13,
                duration: 0.5,
                ease: "bounce.out"
            });
        }
        if (passbook.length > 0) {
            gsap.to(passbook, {
                rotate: -15,
                duration: 0.5,
                ease: "bounce.out"
            });
        }
        if (bagpk.length > 0) {
            gsap.to(bagpk, {
                x: '-3.4%',
                duration: 0.5,
                ease: "bounce.out"
            });
        }
        if (bagbu.length > 0) {
            gsap.to(bagbu, {
                x: '-8%',
                duration: 0.5,
                ease: "bounce.out"
            });
        }
        if (money.length > 0) {
            gsap.to(money, {
                rotate: 23,
                duration: 0.5,
                ease: "bounce.out"
            });
        }
        if (QRcode.length > 0) {
            gsap.to(QRcode, {
                rotate: -20,
                duration: 0.5,
                ease: "bounce.out"
            });
        }
        if (bell.length > 0) {
            gsap.to(bell, {
                rotate: 14,
                duration: 0.5,
                ease: "bounce.out"
            });
        }
        if (dialog.length > 0) {
            gsap.to(dialog, {
                y: '23%',
                duration: 0.5,
                ease: "bounce.out"
            });
        }
    });
    $('.feature-item').on('mouseleave', function () {
        const isMobile = window.matchMedia('(max-width: 767px)').matches;
        if (isMobile) return;

        const dot = $(this).find('.dot');
        const pk = $(this).find('.starpk');
        const yl = $(this).find('.staryl');
        const phone = $(this).find('.phone');
        const passbook = $(this).find('.passbook');
        const money = $(this).find('.money');
        const bagpk = $(this).find('.bagpk');
        const bagbu = $(this).find('.bagbu');
        const QRcode = $(this).find('.QRcode');
        const bell = $(this).find('.bell');
        const dialog = $(this).find('.dialog');

        gsap.to(dot, {
            scale: 0.25,
            duration: 0.5,
            opacity: 0,
            ease: "power2.out"
        });
        gsap.to(pk, {
            scale: 0.4,
            rotate: 45,
            duration: 0.5,
            opacity: 0,
            ease: "power2.out"
        });
        gsap.to(yl, {
            scale: 0.4,
            rotate: -90,
            duration: 0.5,
            opacity: 0,
            ease: "power2.out"
        });
        if (phone.length > 0) {
            gsap.to(phone, {
                rotate: 0,
                duration: 0.5,
                ease: "bounce.out"
            });
        }
        if (passbook.length > 0) {
            gsap.to(passbook, {
                rotate: 0,
                duration: 0.5,
                ease: "bounce.out"
            });
        }
        if (bagpk.length > 0) {
            gsap.to(bagpk, {
                x: 0,
                duration: 0.5,
                ease: "bounce.out"
            });
        }
        if (bagbu.length > 0) {
            gsap.to(bagbu, {
                x: 0,
                duration: 0.5,
                ease: "bounce.out"
            });
        }
        if (money.length > 0) {
            gsap.to(money, {
                rotate: 0,
                duration: 0.5,
                ease: "bounce.out"
            });
        }
        if (QRcode.length > 0) {
            gsap.to(QRcode, {
                rotate: 0,
                duration: 0.5,
                ease: "bounce.out"
            });
        }
        if (bell.length > 0) {
            gsap.to(bell, {
                rotate: 0,
                duration: 0.5,
                ease: "bounce.out"
            });
        }
        if (dialog.length > 0) {
            gsap.to(dialog, {
                y: 0,
                duration: 0.5,
                ease: "bounce.out"
            });
        }
    });
});